import React, {useState} from 'react';
import {Link, Redirect} from 'react-router-dom';
import PersonSelects from "./PersonSelects";

interface Step2cProps {
  persons: string[];
  pSNr: {[key: string]: number};
  setPSNr: React.Dispatch<React.SetStateAction<{[key: string]: number}>>;
  s: {[key: string]: string[]};
  setS: React.Dispatch<React.SetStateAction<{[key: string]: string[]}>>;
}

function Step2c(props: Step2cProps) {
  const { persons, pSNr, setPSNr, s, setS } = props;

  const [redirectTo, setRedirectTo] = useState<string|undefined>(undefined);

  const allFieldFilled = (ids: string[]) => {
    return ids.map((id) => {
      return s[id].filter((f) => f !== '-').length > 0;
    }).every((value) => value);
  }

  const redirect = (e: React.MouseEvent<HTMLButtonElement>, to: string) => {
    e.preventDefault();

    if (!allFieldFilled(['18', '19', '20', '21'])) {
      alert('Bitte alle Felder ausfüllen.');
      return;
    }

    setRedirectTo(to);
  };

  if (redirectTo !== undefined) {
    return (
      <Redirect to={redirectTo} />
    );
  }

  return (
    <div className="step step2c">
      <h2>Schritt 2: Zuständigkeiten</h2>

      <h3>C) Zugriff</h3>

      <p>
        Geben Sie hier bitte jeweils die Personen oder Gruppen an, die im genannten Bereich <strong>praktisch
        handlungsfähig</strong> sind, also tatsächlich Maßnahmen <strong>umsetzen</strong> (und nicht nur
        anordnen) können.
      </p>

      <form>
        <div className="personBlock">
          <p>
            Wer kann das Algorithmensystem kurzfristig (z. B. im Notfall) wieder abschalten?
          </p>
          <PersonSelects id="18" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer kann die Implementierung/geplante Anwendung des Systems ändern?
          </p>
          <PersonSelects id="19" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer kann Daten korrigieren bzw. löschen?
          </p>
          <PersonSelects id="20" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
        <div className="personBlock">
          <p>
            Wer kann Sicherheitsvorkehrungen einrichten?
          </p>
          <PersonSelects id="21" persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
        </div>
      </form>

      <div className="stepNav">
        <Link className="btn btn-secondary" to="/step2b">Zurück</Link>
        <button className="btn btn-primary" onClick={(e) => redirect(e, '/step2d')}>Weiter</button>
      </div>
    </div>
  );
}

export default Step2c
;